import type { ITimeoutService } from "angular";

import type { Observable } from "rxjs";
import { map } from "rxjs/operators";

import type { ILogin, IResponse, IToken } from "App/Modules/Models";
import { IrisitySystems } from "App/Modules/Models";

import type { IHttpService } from "App/Modules/Services";
import type { ITokenRepository } from "./ITokenRepository";

export class TokenRepository implements ITokenRepository {
    public static $inject = ["mmHttpService", "$timeout"];

    constructor(private readonly http: IHttpService, private $timeout: ITimeoutService) {}

    public post(login: ILogin): Observable<IResponse<IToken>> {
        return this.http.post<IToken>("token", login).pipe(
            map((response) => {
                if (!response.data) {
                    return response;
                }

                response.data.validFor = response.data.validFor.map((is) => {
                    return IrisitySystems[is as unknown as keyof typeof IrisitySystems];
                });

                return response;
            }),
        );
    }

    public put(refreshToken: string): Observable<IResponse<IToken>> {
        return this.http.put<IToken>("token", { refreshToken });
    }
}
